module.exports = __webpack_public_path__ + "img/prop-trading-banner-mid.ed54e2c2.png";